<template>
     <div>
         <drop  class="is-inline subLabelContainer"  
            @drop="subBundleDrop(subBundle.id, theInd, ...arguments)" @dragenter="subBundleDragEnter" @dragleave="subBundleDragLeave" @dragend="dragEnd"
            >
             &nbsp; &nbsp; &nbsp;
             <div v-if="showIt" ref="dropMarker" :class="{subLabelDropMarker: subBundle.listName, subLabelDropMarker2: !subBundle.listName}">
                
                 <i class="fa fa-arrow-down"></i>
            </div>
        </drop>
     </div>
</template>

<script>

import { Drag, Drop } from 'vue-drag-drop'


export default {
    props: {
        subBundle: Object,
        //theInd: Number,
        bundleId: Number, //parent
        aliasTgtId: Number
    },

    components: {Drag, Drop},

    data: function(){
        return {
            counter: 0,
            showIt: false,
            theInd: null
        }
    },

    methods: {
        loadSub: function(theInd){
            /* let sb = this.$root.app.bundles.find(e => {
                return e.id == this.subBundle.id
            }) */

            this.$parent.loadSub(this.subBundle, theInd)
        },
        openSubDropdown: function(ind, event){
            event.stopPropagation()
            this.$refs.subDropdowns.classList.toggle('hideIt')
        },
        loadSubFromDropdown: function(b, ind, parent){
            event.stopPropagation()
            this.$parent.riseSubLabel(b, ind)
        },

        dragStart: function(data, e){
            var img = document.getElementById('bundleDraggerSmall')
            e.dataTransfer.setDragImage(img, 0, 30);
        },


        dragEnd: function(){
            this.$refs.subLabel.classList.remove('has-background-coolGreen')
            this.showIt = false;
            this.counter = 0;
        },

        subBundleDragEnter: function(data, event){
           
           if(this.counter == 0){
             
             if(data.type == 'list')
                this.showIt = true
             else
                this.$refs.subLabel.classList.add('has-background-coolGreen');
           }
           this.counter++;
        },

        subBundleDragLeave: function(){
           this.counter--;
           if(this.counter == 0){
              //this.$refs.subLabel.classList.remove('has-background-coolGreen')
              this.showIt = false;
           }
        },

        doDragBIntoCollab: function(payload){
            var self = this;

            function w(d){
                self.$root.app.InitialDataLoad(true)
            }

            function n(){
            }


            this.$root.app.apiClient.put('subs/data/copybintocollab', {id: payload.data.draggedId, index: payload.index, targetId: payload.targetId,  collabId: payload.collabId, parentId: payload.data.bundleId || 'root'}, w, n)
            this.$root.app.closeModal()
        },
        
        subBundleDrop: async function(id, index, data, event){

            //this.$refs.subLabel.classList.remove('has-background-coolGreen');
            this.showIt = false
            this.counter = 0;

            if(data.type == 'card'){

                return

                /* let fromBundleId = data.bundleId
                let cardId = data.cardId
                let cardsIndex = data.cardsIndex
                let toBundleId = id
                let before = false;
                let after;

                let bInd = this.$root.app.bundles.findIndex(e => {
                    return e.id == id
                })

                if(this.$root.app.bundles[bInd].items.length)
                    after = this.$root.app.bundles[bInd].items[0].p;
                else
                    after = false

                let self = this
                function callBack(){
                    //self.$parent.sort()
                    //self.dragging = false

                }

                this.$root.app.cardMover(fromBundleId, cardId, toBundleId, before, after, this.$root.app, callBack, cardsIndex) */

            } else if(data.type == 'list'){

                if(data.draggedId == this.subBundle.id) {
                    return
                }

                if(data.collabId != this.$parent.conts.collabId && (data.collabId && this.$parent.conts.collabId)){
                    this.$root.app.showModalOK({message: "You cannot put a collab bundle into another collab bundle."})
                    return;
                }

                if(data.collabId != this.$parent.conts.collabId && this.$parent.conts.collabId) {
                    this.$root.app.doShowModal('ModalDragbtoc', {message: 'You are dragging a bundle into a collab bundle. Would you like to move it, or create a copy of it.', callBack: this.doDragBIntoCollab, payload: {id:id, index: 'last', targetId: this.$parent.conts.aliasTgtId || this.$parent.conts.id, collabId: this.$parent.conts.collabId, data: data, event: event, branch: this.$parent.conts.branch}})
                    return
                } else if(data.collabId != this.$parent.conts.collabId && !this.$parent.conts.collabId){
                    if(data.fromSub == false){
                         this.$root.app.showModalOK({message: 'Putting collab bundles into other bundles is restricted for now. Stay tuned.'})
                         return
                    } else {
                        if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                            this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                            return
                        }
                        /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                        return */
                    }
                }
                
                let parentCheck = this.$parent.breadCrumbs.findIndex(e => {
                    return e.id == data.draggedId
                })

                if(parentCheck > -1){
                    this.$root.app.showModalOK({message:'You may not move a bundle into one of its children.'})
                    return
                }

                let movedBundle = this.$root.app.bundles.findIndex((e) => {
                    return e.id == data.draggedId
                })

                var copyOfBundle,
                copyOfBundle = this.$root.app.bundles[movedBundle] //JSON.parse(JSON.stringify(this.$root.app.bundles[movedBundle]))

                this.theInd = this.$parent.conts.children.length
         

                if(data.fromSub){
                    this.$root.app.bundleMover(data.bundleId, this.bundleId, this.theInd, copyOfBundle, this.$root.app, this.subBundle.branch, null, null, this.bundleId, this.aliasTgtId, this.$parent.conts.collabId || null);

                } else { 
                    let rootId = copyOfBundle.branch[0]
                    copyOfBundle = this.$root.app.bundles.find(e => {
                        return e.id == rootId;
                    }) 
                    
                    let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == rootId;
                    })

                    
                    this.$root.app.bundleMover('root', this.bundleId, this.theInd, copyOfBundle, this.$root.app, this.subBundle.branch, draggedListIndex, null, null, this.aliasTgtId, this.$parent.conts.collabId || null);
                }
            }

        },
    }
}

</script>